import { RoleTypeEnum } from '@cyberlabrs/helpers';
import {
    AUTHORIZED,
    AUTHORIZED_ADMIN_OWNER,
    AUTHORIZED_ADMIN_OWNER_HR,
    AUTHORIZED_ADMIN_OWNER_HR_PM,
    AUTHORIZED_ADMIN_OWNER_PM,
} from '../../constants';

export const checkIfAdminOrOwner = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return AUTHORIZED_ADMIN_OWNER.includes(roleName);
};
export const checkIfAdminOrOwnerOrHr = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return AUTHORIZED_ADMIN_OWNER_HR.includes(roleName);
};

export const checkIfAdminOrOwnerOrPm = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return AUTHORIZED_ADMIN_OWNER_PM.includes(roleName);
};

export const checkIfOwner = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return roleName === RoleTypeEnum.OWNER;
};

export const checkIfAdminOrOwnerOrHrAndNotSelf = (loggedUserRole: RoleTypeEnum, loggedUserUserSub: string, profilesUserSub: string) => {
    if (loggedUserUserSub === profilesUserSub) return false;
    if (AUTHORIZED_ADMIN_OWNER_HR.includes(loggedUserRole)) return true;
    return false;
};

export const isPrivileged = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return AUTHORIZED_ADMIN_OWNER_HR_PM.includes(roleName);
};

export const isNotPrivileged = (roleName: RoleTypeEnum | undefined): boolean => {
    return !isPrivileged(roleName);
};

export const isAuthorized = (roleName: RoleTypeEnum | undefined): boolean => {
    if (!roleName) return false;
    return AUTHORIZED.includes(roleName);
};
